import { type MessageKey } from '@ecom/i18n';

/**
 * Navigation model — matching exactly the real endpoints this app's own
 * audits found (`platform-admin.controller.ts`, `merchant-admin.
 * controller.ts`, and the Analytics (S17) lot's `platform-analytics.
 * controller.ts`), never a screen for a capability that does not exist
 * yet. No `NavStatus`/'soon' entries the way merchant-dashboard's own
 * `nav.ts` carries: everything named here is real and built, so there is
 * nothing honest to label "Bientôt" — an audit-log/integrations screen
 * would need backend that does not exist (S18's own remaining gap,
 * entrée 74's audit).
 *
 * "Templates notifications" (Notifications Lot 2) was REMOVED with migration 0090: the message
 * texts are code constants and there is nothing to edit.
 */
export interface NavItem {
  readonly labelKey: MessageKey;
  readonly to: string;
  /** Shown only to this platform role (a display hint: the server refuses everybody else anyway). */
  readonly onlyFor?: 'superadmin';
}

export const NAV_ITEMS: readonly NavItem[] = [
  // The superadmin's home (lot K3): the whole platform at a glance.
  { labelKey: 'admin.nav.dashboard', to: '/dashboard', onlyFor: 'superadmin' },
  { labelKey: 'admin.nav.merchants', to: '/merchants' },
  // Who manages which shops, and the shops nobody manages (lot P3).
  { labelKey: 'admin.nav.portfolios', to: '/portfolios', onlyFor: 'superadmin' },
  { labelKey: 'admin.nav.administrators', to: '/administrators', onlyFor: 'superadmin' },
  { labelKey: 'admin.nav.access', to: '/access', onlyFor: 'superadmin' },
  { labelKey: 'admin.nav.security', to: '/security', onlyFor: 'superadmin' },
  // Creating a merchant is the operator's everyday work: open to a platform_admin (and so to a superadmin) - decision D1.
  { labelKey: 'admin.nav.organisations', to: '/organisations' },
  { labelKey: 'merchant.nav.analytics', to: '/analytics' },
  // Everyone's own security history (lot B3).
  { labelKey: 'account.nav', to: '/account' },
];
